import { useLocation } from 'react-router-dom';

const yearFromParam = (yearString: string | null): number =>
  yearString == null ? new Date().getFullYear() : +yearString;

export const useYearFromQueryString = (paramName: string) =>
  yearFromParam(new URLSearchParams(useLocation().search).get(paramName));
